import { IFieldSchema } from "../../../";
import { ProcessDefault } from "./ProcessDefault";
import { IsAvailableType } from "./IsAvailableType";
import { GetInternalMongooseMetaData } from "./GetInternalMongooseMetaData";
import mongoose = require("mongoose");

/**
 * Helper function that will build out the field schema for each object.  This function is meant to
 * rebuild schemas if needed based on the options given to the field.
 * 
 * @param field: IFieldSchema
 *   The field schema we need to scrub before sending it back to mongoose for processing
 * @return: IFieldSchema
 *   Will return a scrubbed IFieldSchema object back for processing by mongoose
 */
export function GetMongooseFieldSchema(field: IFieldSchema): IFieldSchema {
    if (field.ref !== undefined) { // If we are dealing with a reference field we need to alter the type to ObjectId.
        field.type = mongoose.Schema.Types.ObjectId;
        return ProcessDefault(field);
    } else if (IsAvailableType(field.type)) { // If we are dealing with a default object type.
        return ProcessDefault(field);
    } else if(field.type === Object) { // If we are dealing with a standard object we need to specify mixed for the object
        field.type = mongoose.Schema.Types.Mixed;
        return ProcessDefault(field);
    } else if (field.type === Array) { // The array type should never get to this location unless the api is used wrong.
        throw new Error("[FieldArray] decorator must be used with array types. (" + field.name + ")");
    } else { // Deal with embedded items.
        let dataType = field.type;
        delete field.type;
        let schema = GetInternalMongooseMetaData(dataType).schema;
        if (schema === undefined) {
            throw new Error("Embedded schema could not be found for field. (" + field.name + ")");
        }
        return schema;
    }
}